import type { FormFieldState } from 'src/types/formFields';

import { PAGE_ID_CLASSIFY, PAGE_ID_WRITE } from './pageUid';

const CATEGORY_ID = 'categoryId';
const DISPLAY_PAY = 'displayPay';
const JOB_LOCATION_ID = 'jobLocationId';
const JOB_DESCRIPTION = 'jobDescription';
const JOB_SUMMARY = 'jobSummary';
const JOB_TITLE = 'jobTitle';
export const MAX_SALARY = 'maxSalary';
export const MIN_SALARY = 'minSalary';
const PAY_TYPE = 'payType';
const SALARY_TEXT = 'salaryText';
const SUB_CATEGORY_ID = 'subCategoryId';
const VIDEO_URL = 'videoUrl';
const WORK_TYPE = 'workType';

// guidedDetails
export const ABOUT_BUSINESS = 'aboutBusiness';
export const BENEFITS = 'benefits';
export const RESPONSIBILITIES = 'responsibilities';
export const QUALIFICATIONS = 'qualifications';

export const INPUT_MAX_LENGTH_DEFAULT = 50;

export const formFieldObject: FormFieldState = {
  value: '',
  isValid: true,
  message: '',
};

// Specify the required data fields for each page.
// This is used in the withRouteDispatcher enhancer to determine the redirect route
export const requiredPageFields = {
  [PAGE_ID_CLASSIFY]: [
    JOB_TITLE,
    JOB_LOCATION_ID,
    CATEGORY_ID,
    SUB_CATEGORY_ID,
    WORK_TYPE,
    PAY_TYPE,
    MIN_SALARY,
    MAX_SALARY,
    DISPLAY_PAY,
    SALARY_TEXT,
  ],
  [PAGE_ID_WRITE]: [
    QUALIFICATIONS,
    RESPONSIBILITIES,
    BENEFITS,
    ABOUT_BUSINESS,
    JOB_DESCRIPTION,
    JOB_SUMMARY,
  ],
};

// Specify which data fields are optional.
// This is used in the withRouteDispatcher enhancer to determine the redirect route
export const optionalPageFields = [
  ABOUT_BUSINESS,
  BENEFITS,
  SALARY_TEXT,
  VIDEO_URL,
];
